 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import BUNDLE_COVER from '@/components/bundle_cover'
 import EBB from '@/components/ebb'
 import LOVE_1 from '@/components/love_1'
 import BUNDLE_TITLE from '@/components/bundle_title'
 import BUNDLE_CONTENT from '@/components/bundle_content'
 import BOOK1E9780806537009_COV01 from '@/components/Book1/e9780806537009_cov01'
 import BOOK1E9780806537009_TP01 from '@/components/Book1/e9780806537009_tp01'
 import BOOK1E9780806537009_C01 from '@/components/Book1/e9780806537009_c01'
 import BOOK1E9780806537009_C02 from '@/components/Book1/e9780806537009_c02'
 import BOOK1E9780806537009_C03 from '@/components/Book1/e9780806537009_c03'
 import BOOK1E9780806537009_C04 from '@/components/Book1/e9780806537009_c04'
 import BOOK1E9780806537009_C05 from '@/components/Book1/e9780806537009_c05'
 import BOOK1E9780806537009_C06 from '@/components/Book1/e9780806537009_c06'
 import BOOK1E9780806537009_C07 from '@/components/Book1/e9780806537009_c07'
 import BOOK1E9780806537009_C08 from '@/components/Book1/e9780806537009_c08'
 import BOOK1E9780806537009_C09 from '@/components/Book1/e9780806537009_c09'
 import BOOK1E9780806537009_C10 from '@/components/Book1/e9780806537009_c10'
 import BOOK1E9780806537009_C11 from '@/components/Book1/e9780806537009_c11'
 import BOOK1E9780806537009_C12 from '@/components/Book1/e9780806537009_c12'
 import BOOK1E9780806537009_C13 from '@/components/Book1/e9780806537009_c13'
 import BOOK1E9780806537009_C14 from '@/components/Book1/e9780806537009_c14'
 import BOOK1E9780806537009_C15 from '@/components/Book1/e9780806537009_c15'
 import BOOK1E9780806537009_C16 from '@/components/Book1/e9780806537009_c16'
 import BOOK1E9780806537009_C17 from '@/components/Book1/e9780806537009_c17'
 import BOOK1E9780806537009_C18 from '@/components/Book1/e9780806537009_c18'
 import BOOK1E9780806537009_C19 from '@/components/Book1/e9780806537009_c19'
 import BOOK1E9780806537009_C20 from '@/components/Book1/e9780806537009_c20'
 import BOOK1E9780806537009_C21 from '@/components/Book1/e9780806537009_c21'
 import BOOK1E9780806537009_C22 from '@/components/Book1/e9780806537009_c22'
 import BOOK1E9780806537009_C23 from '@/components/Book1/e9780806537009_c23'
 import BOOK1E9780806537009_C24 from '@/components/Book1/e9780806537009_c24'
 import BOOK1E9780806537009_C25 from '@/components/Book1/e9780806537009_c25'
 import BOOK1E9780806537009_C26 from '@/components/Book1/e9780806537009_c26'
 import BOOK1E9780806537009_ACK01 from '@/components/Book1/e9780806537009_ack01'
 import BOOK2E9780806536248_COV01 from '@/components/Book2/e9780806536248_cov01'
 import BOOK2E9780806536248_TP01 from '@/components/Book2/e9780806536248_tp01'
 import BOOK2E9780806536248_FRW01 from '@/components/Book2/e9780806536248_frw01'
 import BOOK2E9780806536248_FM01 from '@/components/Book2/e9780806536248_fm01'
 import BOOK2E9780806536248_C01 from '@/components/Book2/e9780806536248_c01'
 import BOOK2E9780806536248_C02 from '@/components/Book2/e9780806536248_c02'
 import BOOK2E9780806536248_C03 from '@/components/Book2/e9780806536248_c03'
 import BOOK2E9780806536248_C04 from '@/components/Book2/e9780806536248_c04'
 import BOOK2E9780806536248_C05 from '@/components/Book2/e9780806536248_c05'
 import BOOK2E9780806536248_C06 from '@/components/Book2/e9780806536248_c06'
 import BOOK2E9780806536248_C07 from '@/components/Book2/e9780806536248_c07'
 import BOOK2E9780806536248_C08 from '@/components/Book2/e9780806536248_c08'
 import BOOK2E9780806536248_C09 from '@/components/Book2/e9780806536248_c09'
 import BOOK2E9780806536248_C10 from '@/components/Book2/e9780806536248_c10'
 import BOOK2E9780806536248_C11 from '@/components/Book2/e9780806536248_c11'
 import BOOK2E9780806536248_C12 from '@/components/Book2/e9780806536248_c12'
 import BOOK2E9780806536248_C13 from '@/components/Book2/e9780806536248_c13'
 import BOOK2E9780806536248_C14 from '@/components/Book2/e9780806536248_c14'
 import BOOK2E9780806536248_C15 from '@/components/Book2/e9780806536248_c15'
 import BOOK2E9780806536248_C16 from '@/components/Book2/e9780806536248_c16'
 import BOOK2E9780806536248_C17 from '@/components/Book2/e9780806536248_c17'
 import BOOK2E9780806536248_C18 from '@/components/Book2/e9780806536248_c18'
 import BOOK2E9780806536248_C19 from '@/components/Book2/e9780806536248_c19'
 import BOOK2E9780806536248_C20 from '@/components/Book2/e9780806536248_c20'
 import BOOK2E9780806536248_C21 from '@/components/Book2/e9780806536248_c21'
 import BOOK2E9780806536248_C22 from '@/components/Book2/e9780806536248_c22'
 import BOOK2E9780806536248_C23 from '@/components/Book2/e9780806536248_c23'
 import BOOK2E9780806536248_C24 from '@/components/Book2/e9780806536248_c24'
 import BOOK2E9780806536248_BM01 from '@/components/Book2/e9780806536248_bm01'
 import BOOK3E9780806536989_COV01 from '@/components/Book3/e9780806536989_cov01'
 import BOOK3E9780806536989_TP01 from '@/components/Book3/e9780806536989_tp01'
 import BOOK3E9780806536989_FM02 from '@/components/Book3/e9780806536989_fm02'
 import BOOK3E9780806536989_C01 from '@/components/Book3/e9780806536989_c01'
 import BOOK3E9780806536989_C02 from '@/components/Book3/e9780806536989_c02'
 import BOOK3E9780806536989_C03 from '@/components/Book3/e9780806536989_c03'
 import BOOK3E9780806536989_C04 from '@/components/Book3/e9780806536989_c04'
 import BOOK3E9780806536989_C05 from '@/components/Book3/e9780806536989_c05'
 import BOOK3E9780806536989_C06 from '@/components/Book3/e9780806536989_c06'
 import BOOK3E9780806536989_C07 from '@/components/Book3/e9780806536989_c07'
 import BOOK3E9780806536989_C08 from '@/components/Book3/e9780806536989_c08'
 import BOOK3E9780806536989_C09 from '@/components/Book3/e9780806536989_c09'
 import BOOK3E9780806536989_C10 from '@/components/Book3/e9780806536989_c10'
 import BOOK3E9780806536989_C11 from '@/components/Book3/e9780806536989_c11'
 import BOOK3E9780806536989_C12 from '@/components/Book3/e9780806536989_c12'
 import BOOK3E9780806536989_C13 from '@/components/Book3/e9780806536989_c13'
 import BOOK3E9780806536989_C14 from '@/components/Book3/e9780806536989_c14'
 import BOOK3E9780806536989_C15 from '@/components/Book3/e9780806536989_c15'
 import BOOK3E9780806536989_C16 from '@/components/Book3/e9780806536989_c16'
 import BOOK3E9780806536989_C17 from '@/components/Book3/e9780806536989_c17'
 import BOOK3E9780806536989_C18 from '@/components/Book3/e9780806536989_c18'
 import BOOK3E9780806536989_C19 from '@/components/Book3/e9780806536989_c19'
 import BOOK3E9780806536989_C20 from '@/components/Book3/e9780806536989_c20'
 import BOOK3E9780806536989_C21 from '@/components/Book3/e9780806536989_c21'
 import BOOK3E9780806536989_C22 from '@/components/Book3/e9780806536989_c22'
 import BOOK3E9780806536989_C23 from '@/components/Book3/e9780806536989_c23'
 import BOOK3E9780806536989_C24 from '@/components/Book3/e9780806536989_c24'
 import BOOK3E9780806536989_C25 from '@/components/Book3/e9780806536989_c25'
 import BOOK3E9780806536989_C26 from '@/components/Book3/e9780806536989_c26'
 import BOOK3E9780806536989_BM01 from '@/components/Book3/e9780806536989_bm01'
 import BOOK3E9780806536989_ACK01 from '@/components/Book3/e9780806536989_ack01'
 import LOVE_2 from '@/components/love_2'
 import COMONCOPYRIGHT from '@/components/Comon/copyright'
 import BACKADSWEDECKAUBA from '@/components/BackAds/WedeckAUBA'
 import COMONPHILOSOPHICALLIBRARY from '@/components/Comon/PhilosophicalLibrary'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/bundle_content",
 			"name" : "bundle_content",
 			"component" : BUNDLE_CONTENT
 		},
 		{
 			"path" : "/Book1/e9780806537009_cov01",
 			"name" : "Book1/e9780806537009_cov01",
 			"component" : BOOK1E9780806537009_COV01
 		},
 		{
 			"path" : "/Book1/e9780806537009_tp01",
 			"name" : "Book1/e9780806537009_tp01",
 			"component" : BOOK1E9780806537009_TP01
 		},
 		{
 			"path" : "/Book1/e9780806537009_c01",
 			"name" : "Book1/e9780806537009_c01",
 			"component" : BOOK1E9780806537009_C01
 		},
 		{
 			"path" : "/Book1/e9780806537009_c02",
 			"name" : "Book1/e9780806537009_c02",
 			"component" : BOOK1E9780806537009_C02
 		},
 		{
 			"path" : "/Book1/e9780806537009_c03",
 			"name" : "Book1/e9780806537009_c03",
 			"component" : BOOK1E9780806537009_C03
 		},
 		{
 			"path" : "/Book1/e9780806537009_c04",
 			"name" : "Book1/e9780806537009_c04",
 			"component" : BOOK1E9780806537009_C04
 		},
 		{
 			"path" : "/Book1/e9780806537009_c05",
 			"name" : "Book1/e9780806537009_c05",
 			"component" : BOOK1E9780806537009_C05
 		},
 		{
 			"path" : "/Book1/e9780806537009_c06",
 			"name" : "Book1/e9780806537009_c06",
 			"component" : BOOK1E9780806537009_C06
 		},
 		{
 			"path" : "/Book1/e9780806537009_c07",
 			"name" : "Book1/e9780806537009_c07",
 			"component" : BOOK1E9780806537009_C07
 		},
 		{
 			"path" : "/Book1/e9780806537009_c08",
 			"name" : "Book1/e9780806537009_c08",
 			"component" : BOOK1E9780806537009_C08
 		},
 		{
 			"path" : "/Book1/e9780806537009_c09",
 			"name" : "Book1/e9780806537009_c09",
 			"component" : BOOK1E9780806537009_C09
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js